import React, { type ComponentProps, type ReactNode } from 'react'
import { Card, H2, colors } from '@fs/zion-ui'

type Props = {
  heading?: string
  children: ReactNode
  cardProps?: Omit<ComponentProps<typeof Card>, 'children'> & { 'data-testid'?: string }
}

export default function GroupCard({ heading, children, cardProps }: Props): JSX.Element {
  return (
    <Card {...cardProps} edges="border" backgroundColor={colors.gray00} margins="xs">
      {heading && <H2 size="H5">{heading}</H2>}
      {children}
    </Card>
  )
}
